module.exports = __webpack_public_path__ + "img/bg3.ed5551e0.png";